export const BUYER_TYPE_OPTIONS = [
    {
        buyerType: 'first-time-buyer',
        displayedText: 'First time buyer'
    },
    {
        buyerType: 'not-first-time-buyer',
        displayedText: 'I am moving home and this is my only property'
    },
    {
        buyerType: 'second-home',
        displayedText: 'I am buying an additional property'
    }
] as const;

type BuyerType = typeof BUYER_TYPE_OPTIONS[number]['buyerType'];

const calculateNonFirstTimeBuyer = (value: number) => {
    if (value > 1500000)
        return (
            250000 * 0 +
            (925000 - 250000) * 0.05 +
            (1500000 - 925000) * 0.1 +
            (value - 1500000) * 0.12
        );
    if (value > 925000)
        return 250000 * 0 + (925000 - 250000) * 0.05 + (value - 925000) * 0.1;
    if (value > 250000) return 250000 * 0 + (value - 250000) * 0.05;
    return 0;
};

const calculateFirstTimeBuyer = (value: number) => {
    if (value > 625000) return calculateNonFirstTimeBuyer(value);
    if (value > 425000) return 425000 * 0 + (value - 425000) * 0.05;
    return 0;
};

const calculateSecondHome = (value: number) => {
    return calculateNonFirstTimeBuyer(value) + value * 0.03;
};

const calculateStampDuty = (buyerType: BuyerType, price: number) => {
    switch (buyerType) {
        case 'not-first-time-buyer':
            return calculateNonFirstTimeBuyer(price);
        case 'first-time-buyer':
            return calculateFirstTimeBuyer(price);
        case 'second-home':
            return calculateSecondHome(price);
    }
};

const parseBuyerType = (type: string): BuyerType | null => {
    let parsedBuyerType: BuyerType | null = null;
    BUYER_TYPE_OPTIONS.forEach(({ buyerType }) => {
        if (buyerType === type) {
            parsedBuyerType = buyerType;
        }
    });
    return parsedBuyerType;
};

export { calculateStampDuty, parseBuyerType };
export type { BuyerType };
